<template>
  <div class="vue-NewNativePromotionPage">
    <div
      v-if="getCurrentLandingPageData ? loading : false"
      class="NewNativePromotionPage_loading"
    >
      <img src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fi0.hdslb.com%2Fbfs%2Farticle%2F0d31f33428da3aeb658feee1c88bbeef84f4e8cc.gif&refer=http%3A%2F%2Fi0.hdslb.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1647761330&t=6df94131c1a90503ded08226ce07d72c">
    </div>
    <NewNativePromotionPage
      v-else
      :account_id="$route.query.account_id"
      :be-based-on="$route.query.beBasedOn"
      :components="components"
      :information="information"
      :name="name"
      :message="$message"
      :go-public="goPublic"
      :go-tx="goTx"
    />
  </div>
</template>

<script>
import NewNativePromotionPage from './index.jsx'
import React from 'react'
import { mapGetters } from 'vuex'
import { datas } from './datas.js'
console.log(React)

export default {
  components: {
    NewNativePromotionPage
  },
  data() {
    return {
      components: [
        {
          back: '#ffffff',
          comps: [
          ]
        }
      ],
      information: {
        title: '',
        name: '',
        gzh: '',
        back: '#ffffff'
      },
      name: '',
      loading: true
    }
  },
  computed: {
    ...mapGetters(['getCurrentLandingPageData'])
  },
  watch: {
    components(newComp) {
      this.components = newComp
    }
  },

  beforeDestroy() {
    this.$store.commit('landingPage/setCurrentLandingPageData', null)
    window.removeEventListener('beforeunload', this.beforeunloadHandler)
  },

  mounted() {
    if (this.getCurrentLandingPageData) {
      const comps = this.parseData()
      const will = JSON.parse(this.getCurrentLandingPageData.json_info).content.content.pageConfig.config
      this.components = [{ back: '#ffffff', comps }]
      this.information = {
        title: will.pageTitle,
        name: will.pageName,
        gzh: '',
        back: will.bgColor
      }
      this.loading = false
    }

    window.addEventListener('beforeunload', this.beforeunloadHandler)
  },
  methods: {
    beforeunloadHandler(e) {
      e = e || window.event
      if (e) {
        e.returnValue = '您是否确认离开此页面-您输入的数据可能不会被保存'
      }
      return '您是否确认离开此页面-您输入的数据可能不会被保存'
    },

    parseData() {
      const modules = JSON.parse(this.getCurrentLandingPageData.json_info).content.content.modules
      const comps = []
      let ifon = null
      let item = null
      for (let i = 0; i < modules.length; i++) {
        if (modules[i].type === 'YBImages') {
          ifon = this.image_comp(modules[i].config.images)
          item = this.getComp('image_comp')
        } else if (modules[i].type === 'YBText') {
          ifon = this.text_comp(modules[i].config)
          item = this.getComp('text_comp')
        } else if (modules[i].type === 'YBWXButton') {
          ifon = this.button_comp(modules[i].config)
          item = this.getComp('button_comp')
        }
        comps.push({
          id: Math.random(),
          name: item.name,
          comp: item.contentComp,
          copyComp: item.contentCopyComp,
          sideComp: item.sideComp,
          ifon: ifon
        })
      }

      return comps
    },

    image_comp(images) {
      const imageList = []
      const s = [[1], [1, 2], [1, 2, 3]]
      const te = {
        backTop: 0,
        backBottom: 1,
        gzh: 2,
        link: 3
      }
      const func = (hotAreaTarget, imageTarget) => {
        const w = (375 / 100) * 30
        const h = (imageTarget.image.height / 100) * 30
        const x = (375 / 100) * 20
        const y = (imageTarget.image.height / 100) * 20
        return {
          width: hotAreaTarget ? hotAreaTarget.style.width / 100 * 375 : w,
          height: hotAreaTarget ? hotAreaTarget.style.height / 100 * imageTarget.image.height : h,
          x: hotAreaTarget ? hotAreaTarget.position.left / 100 * 375 : x,
          y: hotAreaTarget ? hotAreaTarget.position.top / 100 * imageTarget.image.height : y,
          goTo: hotAreaTarget ? te[hotAreaTarget.linkType] : 0,
          link: hotAreaTarget ? hotAreaTarget.link.url : '',
          gzh: '',
          Width: hotAreaTarget ? 375 - hotAreaTarget.position.left : 375 - x,
          Height: hotAreaTarget ? imageTarget.image.height - hotAreaTarget.position.top : imageTarget.image.height - y,
          X: hotAreaTarget ? 375 - hotAreaTarget.style.width : 375 - w,
          Y: hotAreaTarget ? imageTarget.image.height - hotAreaTarget.style.height : imageTarget.image.height - h,
          id: Math.random()
        }
      }
      for (let i = 0; i < images.length; i++) {
        const item = images[i]
        imageList.push({
          fileIfon: {
            file: null,
            height: item.image.height,
            width: '100%',
            src: item.image.url,
            zSrc: item.image.url,
            zWidth: null,
            zHeight: null,
            paddingTop: item.padding.top,
            paddingBottom: item.padding.bottom,
            paddingLeft: item.padding.left,
            paddingRight: item.padding.right
          },
          hotZone: [func(item.hotArea1, item), func(item.hotArea2, item), func(item.hotArea3, item)],
          id: Math.random(),
          isHotZone: item.hotArea.isSet,
          hotZoneQuantity: s[`${item.hotArea.num - 1}`]
        })
      }

      return {
        currentIndex: 0,
        imageList
      }
    },

    text_comp(config) {
      const obj = {
        'border-none': 0,
        'border-dott': 1,
        'border-solid': 2,
        'border-dashed': 3,
        'border-dobbule-solid': 4
      }

      return {
        html: config.content.differRichEditor ? config.content.differRichEditor : '',
        color: config.style.color,
        paddingTop: config.style.marginTop,
        paddingBottom: config.style.marginBottom,
        paddingLeft: config.style.marginLeft,
        paddingRight: config.style.marginRight,
        isFrame: config.isSetBorder,
        textStyle: obj[config.border.style],
        frameColor: config.border.color,
        thickness: config.border.width,
        fillet: config.border.radius,
        framePaddingTop: config.style.paddingTop,
        framePaddingBottom: config.style.paddingBottom,
        framePaddingLeft: config.style.paddingLeft,
        framePaddingRight: config.style.paddingRight
      }
    },

    button_comp(config) {
      const obj = {
        left: 0,
        center: 1,
        right: 2
      }
      return {
        link: config.content.url,
        text: config.content.text,
        color: config.style.color,
        colorBack: config.style.backgroundColor,
        fontSize: config.style.fontSize,
        width: config.style.width,
        height: config.style.lineHeight,
        fillet: config.style.borderRadius,
        layout: obj[config.wrapper.textAlign],
        paddingTop: config.wrapper.marginTop,
        paddingBottom: config.wrapper.marginBottom,
        paddingLeft: config.wrapper.marginLeft,
        paddingRight: config.wrapper.marginRight,
        isSuspension: config.position.isFixed,
        bottomDistance: config.position.toBottom,
        message: config.position.whiteSpace
      }
    },

    getComp(name) {
      for (let i = 0; i < datas.length; i++) {
        for (let l = 0; l < datas[i].data.length; l++) {
          if (datas[i].data[l].name === name) {
            return datas[i].data[l]
          }
        }
      }
    },

    goPublic() {
      this.$router.replace('/customer/publicReadingTreasure/index')
    },

    goTx(account_id) {
      this.$router.replace({
        path: '/nativePAGE/index',
        query: {
          account_id: account_id || this.$route.account_id
        }
      })
    }
  }

}
</script>

<style scoped lang="less">
.vue-NewNativePromotionPage {
  height: 100%;
  div {
    height: 100%;
  }
  .NewNativePromotionPage_loading {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
